@if (toaster?.visible) {
  <div
    class="toaster-container row p-0 m-0"
    [ngClass]="toaster?.type"
    [@toasterAnimation]
    [@hoverAnimation]="isHovered ? 'hovered' : 'default'"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    >
    <div class="col-2 d-flex align-items-center justify-content-center icon-section">
      @if (toaster?.type === 'success') {
        <img src="svg/toast_icons/success.svg" alt="Success Icon" />
      }
      @if (toaster?.type === 'error') {
        <img src="svg/toast_icons/error.svg" alt="Error Icon" />
      }
      @if (toaster?.type === 'warning') {
        <img src="svg/toast_icons/warning.svg" alt="Warning Icon" />
      }
    </div>
    <div class="col-10 content-section text-dark bg-white">
      <strong>{{ toaster?.type | titlecase }}!</strong>
      <p>
        {{ toaster?.message }}
        @if (toaster?.linkText && toaster?.linkCallback) {
          <a
            href="javascript:void(0);"
            (click)="onLinkClick($event)"
            class="toaster-link"
            >
            {{ toaster?.linkText }}
          </a>
        }
      </p>
    </div>
  </div>
}
